import { Datagrid, IfCanAccess, List } from "src/enterprise/ra-rbac";
import * as React from "react";
import { FunctionField, TextInput, TextField, EditButton } from "react-admin";
import { AttributeTypeEnum } from "../../../common/enum";

const listFilters = [<TextInput source="search" label="Search" alwaysOn />];

export const AttributeList = (props) => {
  return (
    <List {...props} filters={listFilters} queryOptions={{ cacheTime: 0 }}>
      <Datagrid>
        <TextField source="id" />
        <TextField source="code" />
        <TextField source="name" />
        <FunctionField
          label="Type"
          render={(record) =>
            AttributeTypeEnum.find((x) => x.id === record.type)?.name
          }
        />
        <IfCanAccess action="edit">
          <EditButton />
        </IfCanAccess>
      </Datagrid>
    </List>
  );
};
